<div class="container-fluid">
  <div class="row">
    <!-- Coluna Principal - Cronogramas -->
    <div class="col-md-4 col-lg-3">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">Cronogramas</h4>
          <button class="btn btn-sm btn-primary" (click)="abrirModalNovoCronograma()">
            <i class="feather icon-plus"></i> Novo
          </button>
        </div>
        <div class="card-body p-0">
          <div class="list-group list-group-flush">
            <a *ngFor="let cronograma of cronogramas" 
               href="javascript:void(0)" 
               class="list-group-item list-group-item-action"
               [class.active]="cronogramaSelecionado?.id === cronograma.id"
               (click)="expandirCronograma(cronograma)">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-0">{{ cronograma.nome }}</h6>
                  <small class="text-muted">{{ cronograma.dataCriacao | date:'dd/MM/yyyy HH:mm' }}</small>
                </div>
                <div>
                  <button class="btn btn-sm btn-outline-primary mr-2" (click)="editarCronograma(cronograma); $event.stopPropagation()">
                    <i class="feather icon-edit"></i>
                  </button>            
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Coluna de Itens -->
    <div class="col-md-4 col-lg-3" *ngIf="cronogramaSelecionado">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">Itens</h4>
          <button class="btn btn-sm btn-primary" (click)="novoItem()">
            <i class="feather icon-plus"></i> Novo
          </button>
        </div>
        <div class="card-body p-0">
          <div class="list-group list-group-flush">
            <a *ngFor="let item of itens" 
               href="javascript:void(0)" 
               class="list-group-item list-group-item-action"
               [class.active]="itemSelecionado?.idCronogramaItemBase === item.idCronogramaItemBase"
               (click)="expandirItem(item)">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-0">{{ item.nome }}</h6>
                  <small class="text-muted">Ordem: {{ item.ordem }} | Prazo: {{ item.prazoEmDias }} dias</small>
                </div>
                <button class="btn btn-sm btn-outline-primary" (click)="editarItem(item); $event.stopPropagation()">
                  <i class="feather icon-edit"></i>
                </button>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Coluna de Opções -->
    <div class="col-md-4 col-lg-3" *ngIf="itemSelecionado">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">Opções</h4>
          <button class="btn btn-sm btn-primary" (click)="abrirModalNovaOpcao()">
            <i class="feather icon-plus"></i> Novo
          </button>
        </div>
        <div class="card-body p-0">
          <div class="list-group list-group-flush">
            <a *ngFor="let opcao of opcoes" 
               href="javascript:void(0)" 
               class="list-group-item list-group-item-action"
               [class.active]="opcaoSelecionada?.idCronogramaItemOpcaoBase === opcao.idCronogramaItemOpcaoBase"
               (click)="selecionarOpcao(opcao)">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-0">{{ opcao.nome }}</h6>
                  <small class="text-muted">Ordem: {{ opcao.ordem }}</small>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Coluna de Detalhes -->
    <div class="col-md-4 col-lg-3" *ngIf="opcaoSelecionada">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Detalhes da Opção</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="opcaoForm" (ngSubmit)="salvarOpcao()">
            <div class="form-group">
              <label>Nome</label>
              <input type="text" class="form-control" formControlName="nome">
            </div>
            <div class="form-group">
              <label>Ordem</label>
              <input type="number" class="form-control" formControlName="ordem">
            </div>
            <div class="form-group">
              <label for="tipoOpcao">Tipo de Opção</label>
              <select class="form-control" id="tipoOpcao" formControlName="idTipoOpcao" (change)="onTipoOpcaoChange($event.target.value)">
                <option *ngFor="let tipo of tiposOpcao" [value]="tipo.id">{{tipo.nome}}</option>
              </select>
            </div>
            <div class="form-group" *ngIf="opcaoForm.get('idTipoOpcao').value === '1'">
              <label for="formulario">Formulário</label>
              <select class="form-control" id="formulario" formControlName="idTriagem">
                <option value="">Selecione um formulário</option>
                <option *ngFor="let triagem of triagens" [value]="triagem.id">{{triagem.titulo}}</option>
              </select>
              <div class="invalid-feedback" *ngIf="opcaoForm.get('idTriagem').invalid && opcaoForm.get('idTriagem').touched">
                Por favor, selecione um formulário.
              </div>
            </div>
            <button type="submit" class="btn btn-primary">Salvar</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Novo Cronograma -->
<ng-template #modalNovoCronograma>
  <div class="modal-header">
    <h5 class="modal-title">Novo Cronograma</h5>
    <button type="button" class="close" (click)="modalService.dismissAll()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="cronogramaForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="nome">Nome do Cronograma</label>
        <input type="text" class="form-control" id="nome" formControlName="nome" placeholder="Digite o nome do cronograma">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="!cronogramaForm.valid">Salvar</button>
  </div>
</ng-template>

<!-- Modal Novo Item -->
<ng-template #modalNovoItem>
  <div class="modal-header">
    <h5 class="modal-title">Novo Item</h5>
    <button type="button" class="close" (click)="modalService.dismissAll()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="itemForm" (ngSubmit)="salvarItem()">
      <div class="form-group">
        <label for="nomeItem">Nome do Item</label>
        <input type="text" class="form-control" id="nomeItem" formControlName="nome" placeholder="Digite o nome do item">
      </div>
      <div class="form-group">
        <label for="descricaoItem">Descrição</label>
        <textarea class="form-control" id="descricaoItem" formControlName="descricao" rows="3" placeholder="Digite a descrição do item"></textarea>
      </div>
      <div class="form-group">
        <label for="ordemItem">Ordem</label>
        <input type="number" class="form-control" id="ordemItem" formControlName="ordem" min="0" step="0.01">
      </div>
      <div class="form-group">
        <label for="prazoEmDiasItem">Prazo em Dias</label>
        <input type="number" class="form-control" id="prazoEmDiasItem" formControlName="prazoEmDias" min="0">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="salvarItem()" [disabled]="!itemForm.valid">Salvar</button>
  </div>
</ng-template>

<!-- Modal Nova Opção -->
<ng-template #modalNovaOpcao>
  <div class="modal-header">
    <h5 class="modal-title">Nova Opção</h5>
    <button type="button" class="close" (click)="modalService.dismissAll()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="opcaoForm" (ngSubmit)="salvarOpcao()">
      <div class="form-group">
        <label for="nomeOpcao">Nome da Opção</label>
        <input type="text" class="form-control" id="nomeOpcao" formControlName="nome" placeholder="Digite o nome da opção">
      </div>
      <div class="form-group">
        <label for="ordemOpcao">Ordem</label>
        <input type="number" class="form-control" id="ordemOpcao" formControlName="ordem" min="0" step="0.01">
      </div>
      <div class="form-group">
        <label for="tipoOpcao">Tipo de Opção</label>
        <select class="form-control" id="tipoOpcao" formControlName="idTipoOpcao" (change)="onTipoOpcaoChange($event.target.value)">
          <option *ngFor="let tipo of tiposOpcao" [value]="tipo.id">{{tipo.nome}}</option>
        </select>
      </div>
      <div class="form-group" *ngIf="opcaoForm.get('idTipoOpcao').value === '1'">
        <label for="formulario">Formulário</label>
        <select class="form-control" id="formulario" formControlName="idTriagem">
          <option value="">Selecione um formulário</option>
          <option *ngFor="let triagem of triagens" [value]="triagem.id">{{triagem.titulo}}</option>
        </select>
        <div class="invalid-feedback" *ngIf="opcaoForm.get('idTriagem').invalid && opcaoForm.get('idTriagem').touched">
          Por favor, selecione um formulário.
        </div>
      </div>
      <div class="form-group">
        <label for="descricaoOpcao">Descrição</label>
        <textarea class="form-control" id="descricaoOpcao" formControlName="descricao" rows="3" placeholder="Digite a descrição da opção"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="salvarOpcao()" [disabled]="!opcaoForm.valid">Salvar</button>
  </div>
</ng-template> 